var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',[_c('Header',{attrs:{"need-handle-search":false},on:{"handle-search":_vm.handleSearch}}),_c('div',{attrs:{"id":"allmap"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }